export default "__VITE_ASSET__C8t1793h__"